import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';
import { NgxPaginationModule } from 'ngx-pagination';
import { OutcomeActionManagementModalPage } from './outcome-action-management-modal.page';

const routes: Routes = [
  {
    path: '',
    component: OutcomeActionManagementModalPage
  }
];

@NgModule({
  imports: [
    NgxPaginationModule,
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [OutcomeActionManagementModalPage]
})
export class OutcomeActionManagementModalPageModule {}
